// Import react libs
import { Link } from 'react-router-dom';

// Import style lib
import styled from 'styled-components';

// Styled wrapper for the footer
export const FooterWrapper = styled.footer`
    /* Size */
    height: 70px;
    width: 100%;

    /* Element disposition */
    flex-shrink: 0;
    position: relative;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: space-between;

    /* Spacing */
    padding: 0px 15px;

    /* Visual effects */
    box-shadow: 0px -4px 6px rgba(0, 0, 0, 0.5);
`;

// Styled left section
export const LeftSection = styled.section`
    /* Content disposition */
    display: flex;
    align-items: center;
    gap: 10px;
`;

// Styled right section
export const RightSection = styled.section`
    /* Content disposition */
    display: flex;
    align-items: center;
    gap: 15px;
`;

// Styled links
export const LegalLinks = styled(Link)`
    /* Events */
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;

// Styled external link
export const ExternalLink = styled.a`
    /* Events */
    &:hover {
        filter: brightness(1.2);
    }
`;

// Styled svg
export const Icon = styled.svg`
    /* Size */
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;
`;

// Styled Logo
export const Logo = styled.img`
    /* Size */
    width: ${(props) => props.width}px;

    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }
`;
